import { c as _c } from "react/compiler-runtime";
import React from "react";
import { cn } from "@/lib/utils";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
export interface InfoCardItem {
  title: string;
  value: string | React.ReactNode;
  icon?: React.ReactNode;
}
interface InfoCardProps {
  items: InfoCardItem[];
  className?: string;
  actions?: React.ReactNode;
  badges?: React.ReactNode;
  variant?: "default" | "strip";
}
export const InfoCard = t0 => {
  const $ = _c(32);
  const {
    items,
    className,
    actions,
    badges,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  if (variant === "strip") {
    let t2;
    if ($[0] !== className) {
      t2 = cn("flex items-center gap-2", className);
      $[0] = className;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== items) {
      t3 = items.map(_temp);
      $[2] = items;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] !== actions) {
      t4 = actions && <div className="flex items-center justify-center gap-1 pl-2 flex-shrink-0 ml-auto">{actions}</div>;
      $[4] = actions;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    let t5;
    if ($[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
      t5 = <div className={t2}>{t3}{t4}</div>;
      $[6] = t2;
      $[7] = t3;
      $[8] = t4;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    return t5;
  }
  let t2;
  if ($[10] !== className) {
    t2 = cn("flex flex-col border rounded-lg text-sm bg-[var(--color-surface)] w-full overflow-hidden h-full", className);
    $[10] = className;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  const t3 = actions && "pr-16";
  let t4;
  if ($[12] !== t3) {
    t4 = cn("flex flex-row flex-1 h-full items-center justify-between", t3);
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== items) {
    let t6;
    if ($[16] !== items.length) {
      t6 = (item_0, index_0) => <React.Fragment key={index_0}><div className={cn("flex flex-col items-start min-w-0 flex-1", !item_0.title ? "" : "gap-1", !item_0.title ? "p-0" : "px-2")} style={!item_0.title ? {
          padding: 0
        } : undefined}><div className={cn("flex flex-col items-start min-w-0 w-full", !item_0.title ? "" : "gap-1", index_0 !== items.length - 1 && "border-r border-[var(--color-border)] dark:border-[var(--color-border)] pr-2")}>{item_0.title && <div className="flex items-center gap-1 w-full min-w-0 h-3">{item_0.icon && <span className="text-neutral-400 dark:text-neutral-400 flex-shrink-0">{item_0.icon}</span>}<span className="text-neutral-500 dark:text-neutral-400 text-xs font-medium uppercase tracking-wide truncate">{item_0.title}</span></div>}{typeof item_0.value === "string" ? (() => {
              const isTruncated = item_0.value.length > 24;
              const displayValue = isTruncated ? item_0.value.substring(0, 24) + "..." : item_0.value;
              if (isTruncated) {
                return <TooltipProvider><Tooltip><TooltipTrigger asChild={true}><span className="text-base truncate w-full leading-[1.25rem] h-5 flex items-baseline cursor-help mt-1">{displayValue}</span></TooltipTrigger><TooltipContent><p className="max-w-xs break-words">{item_0.value}</p></TooltipContent></Tooltip></TooltipProvider>;
              }
              return <span className="text-base truncate w-full leading-[1.25rem] h-5 flex items-baseline mt-1">{displayValue}</span>;
            })() : <div className="leading-[1.25rem] w-full flex items-baseline mt-0.5 h-5">{item_0.value}</div>}</div></div></React.Fragment>;
      $[16] = items.length;
      $[17] = t6;
    } else {
      t6 = $[17];
    }
    t5 = items.map(t6);
    $[14] = items;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[18] !== t4 || $[19] !== t5) {
    t6 = <div className={t4}>{t5}</div>;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== actions) {
    t7 = actions && <div className="flex items-center gap-2 ml-4 flex-shrink-0 absolute top-4 right-4">{actions}</div>;
    $[21] = actions;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t6 || $[24] !== t7) {
    t8 = <div className="flex flex-row items-center justify-between pt-4 pl-4 pb-4 pr-4 h-full w-full relative">{t6}{t7}</div>;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== badges) {
    t9 = badges && <div className="flex items-center justify-between gap-2 px-4 pt-4 pb-3"><div className="flex items-center gap-2">{badges}</div></div>;
    $[26] = badges;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== t2 || $[29] !== t8 || $[30] !== t9) {
    t10 = <div className={t2}>{t8}{t9}</div>;
    $[28] = t2;
    $[29] = t8;
    $[30] = t9;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  return t10;
};
function _temp(item, index) {
  return <div key={index} className="flex flex-col gap-0.5 items-start min-w-0 border-l border-[var(--color-border)]/70 dark:border-[var(--color-border)]/70 px-2 py-0"><p className="type-body-xxs-regular text-neutral-500 dark:text-neutral-400 truncate max-w-full uppercase">{item.title}</p>{typeof item.value === "string" ? <p className="type-body-xxs-regular text-neutral-700 dark:text-neutral-200 truncate max-w-full">{item.value}</p> : <div className="type-body-xxs-regular text-neutral-700 dark:text-neutral-200 truncate max-w-full">{item.value}</div>}</div>;
}